// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lk-3";
export var downloadButton = "_lk-4";
export var fileContainer = "_lk-9 _lk-7";
export var fileContainerBase = "_lk-7";
export var fileContainerBaseSm = "_lk-a _lk-7";
export var fileContainerFixedHeight = "_lk-8 _lk-7";
export var fileContainerFixedHeightSm = "_lk-c _lk-a _lk-7";
export var fileContainerSm = "_lk-b _lk-a _lk-7";
export var fileInfo = "_lk-5";
export var fileInfoWidthRestricted = "_lk-6";
export var fileType = "_lk-1";
export var fileTypeName = "_lk-2";
export var fileTypeSm = "_lk-d _lk-1";
export var image = "_lk-0";
export var link = "_lk-f";
export var overflowEllipsis = "_lk-e";